import { render, staticRenderFns } from "./gestion-caisse.html?vue&type=template&id=4995fdd7&scoped=true&external"
import script from "./gestion-caisse.js?vue&type=script&lang=js&external"
export * from "./gestion-caisse.js?vue&type=script&lang=js&external"
import style0 from "./gestion-caisse.scss?vue&type=style&index=0&id=4995fdd7&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4995fdd7",
  null
  
)

export default component.exports